import { useQuery, useMutation } from "@apollo/client/react"; import React, { useEffect, useState, useMemo } from 'react';
import { Button, Grid } from '@mui/material';
import { adaptCombosRIArray } from '../../../../adapters/resumenIngreso/combosRIAdapter';

import { getStringQueryCombosRI } from '../../../../data/graphQL/queries/ResumenIngreso/getAllCombosRI';
import { RadioGroupInput } from '../../../../components/radioGroupInput/RadioGroupInput';

export const StepRequerimientosAdicionales = ({
  selectedPrograms,
  setDataSubmissionCallback,
  updateFormData,
  fullFormDataRI
}) => {
  const [requerimientosAdicionales, setRequerimientosAdicionales] = useState(fullFormDataRI?.requerimientosAdicionales ?? {});
  const [combosRI, setCombosRI] = useState();

  useEffect(() => {
    setDataSubmissionCallback(handleSubmit);
  }, [requerimientosAdicionales, setDataSubmissionCallback]);

  const handleSubmit = () => {
    updateFormData('requerimientosAdicionales', {
      ...requerimientosAdicionales
    });
  };

  const handleChange = (name, value) => {
    setRequerimientosAdicionales((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }));
  };

  const getOptionsByName = (fieldName) => {
    const combos = {
      'idComboRIValorReqAdicional': combosRI?.idComboRIValorReqAdicional?.map((option) => { return { label: option.displayName, value: option.id }; })
    };

    return combos[fieldName] || [];
  };

  const inputCombos = inputsGroups.flatMap((inputgroup) => {
    return inputgroup.inputs.filter((input) => !!input.comboName);
  });

  const { data: combosData } = useQuery(getStringQueryCombosRI(inputCombos), {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!combosData) return;

    setCombosRI(adaptCombosRIArray(combosData));
  }, [combosData]);

  const validatedinputsGroups = useMemo(() => {
    const updatedRequired = inputsGroups.map((group) => ({
      ...group,
      inputs: group.inputs.map((prevInput) => {
        return {
          ...prevInput,
          options: prevInput.type === 'select' || prevInput.type.includes('multiple') ? getOptionsByName(prevInput.name) : []
        };
      })
    }));

    return updatedRequired;
  }, [selectedPrograms, combosRI]);


  return (
    <div>
      {validatedinputsGroups.map((group) =>
        <div className='step-form-section-container' key={group.groupName}>
          <label className='step-form-section-title'>{group.groupName}</label>
          <Grid container>
            {group.inputs.map((input) => {
              return (
                <RadioGroupInput
                  key={input.name}
                  adicionalValues={requerimientosAdicionales[input.name]}
                  inputName={input.name}
                  options={input.options}
                  onChange={handleChange}
                  row={false} />);


            })}
          </Grid>
        </div>
      )
      }
    </div>);

};

export default StepRequerimientosAdicionales;

const inputsGroups = [
  {
    groupName: 'Adicionales',
    inputs: [
      {
        displayName: '',
        name: 'idComboRIValorReqAdicional',
        comboName: 'Adicionales',
        type: 'multiple_boolean',
        options: [],
        required: true
      }]

  }];